import { MFA_TYPE_VALUES } from "../../dashboard/admin/users/enum/mfaTypes";

export const MFA_PREFERENCE_FORM_VALIDATION_RULES = {
  mfaType: {
    isRequiredIn: {
      value: MFA_TYPE_VALUES,
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/common/MFAPreference/MFAPreferenceFormValidationRules.js